// We use this custom approach instead of the native `:focus-visible`
// because some browsers show focus styles on mouse clicks on form elements
// (not only when using keyboard navigation).
export default defineNuxtPlugin(() => {
	const body = document.body;

	function onKeyDown(e: KeyboardEvent) {
		if (e.key === 'Tab' && !body.classList.contains('custom-focus-visible')) {
			body.classList.add('custom-focus-visible');
		}
	}

	function onMouseDown() {
		if (body.classList.contains('custom-focus-visible')) {
			body.classList.remove('custom-focus-visible');
		}
	}

	window.addEventListener('keydown', onKeyDown);
	window.addEventListener('mousedown', onMouseDown);
});
